<template>
    <CDropdown
        in-nav
        class="c-header-nav-items"
        placement="bottom-end"
        add-menu-classes="pt-0"
    >
        <template #toggler>
            <CHeaderNavLink>
                <div class="c-avatar">
                    <img
                        src="/img/avatars/profile.png"
                        class="c-avatar-img "
                    />
                </div>
            </CHeaderNavLink>
        </template>
        <div class="dropdown-item-custom">
            <div>
                <CIcon name="cil-volume-high" /> Звуки заказов
            </div>
            <label class="c-switch c-switch-label c-switch-opposite-primary mb-0">
                <input
                    type="checkbox"
                    class="c-switch-input"
                    :checked="soundsOn"
                    @change="setOrderSounds" />
                <span
                    class="c-switch-slider"
                    data-checked="✓"
                    data-unchecked="✗"></span>
            </label>
        </div>
        <div class="dropdown-item-custom">
            <div class="pr-2">
                <CIcon name="cil-volume-high" /> Звуки сообщений
            </div>
            <label class="c-switch c-switch-label c-switch-opposite-primary mb-0">
                <input
                    type="checkbox"
                    class="c-switch-input"
                    :checked="chatSoundsOn"
                    @change="setChatSounds" />
                <span
                    class="c-switch-slider"
                    data-checked="✓"
                    data-unchecked="✗"></span>
            </label>
        </div>
        <CDropdownItem @click="profile">
            <CIcon name="cil-user" /> Профиль
        </CDropdownItem>
        <CDropdownItem @click="logout">
            <CIcon name="cil-lock-locked" /> Выйти
        </CDropdownItem>
    </CDropdown>
</template>

<script>
    import { mapState } from 'vuex';
    import store from '@/store';

    import { AUTH_LOGOUT } from '../store/actions/auth';

    export default {
        name: 'TheHeaderDropdownAccnt',
        data () {
            return { 
                itemsCount: 42,
            }
        },
        computed: {
            ...mapState('settings', ['soundsOn', 'chatSoundsOn'])
        },
        mounted() {
            store.dispatch('settings/fetch');
        },
        methods: {
            logout: function() {
                this.$store.dispatch(AUTH_LOGOUT)
                    .then( () => {
                        location.reload();
                    });
            },
            profile: function() {
                this.$router.push('/profile');
            },
            setOrderSounds($e) {
                store.commit('settings/SET_SOUNDS', $e.target.checked);
            },
            setChatSounds($e) {
                store.commit('settings/SET_CHAT_SOUNDS', $e.target.checked);
            }
        }
    }
</script>

<style scoped>
    .dropdown-item-custom {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -ms-flex-align: center;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        padding: 0.5rem 1.25rem;
        clear: both;
        font-weight: 400;
        text-align: inherit;
        white-space: nowrap;
        background-color: transparent;
        border: 0;
        color: #4f5d73;
        border-bottom: 1px solid #4f5d73;
    }
    .c-icon {
        margin-right: 0.3rem;
    }
</style>
